/* Per-screen entry for /library/:id/markers.
 *
 * Forward-ported from frontend-v2 to the real Convex persistence path
 * (read `assetQueries.getAssetWithMarkers` → write
 * `mutations.assets.updateAdMarkersV2`). The previous body re-exported a
 * mock from `_bundle.tsx` that hardcoded two fake markers in local state.
 *
 * `MarkerEditorPage` pulls in the headless Vidstack `<AssetPlayer>` (and
 * its codec chunks), so it is code-split behind `React.lazy`: the player
 * + editor bundle loads ONLY when this route mounts, keeping it out of the
 * main entry chunk for every other screen.
 */
import { lazy, Suspense, type JSX } from 'react';

const MarkerEditorPage = lazy(() => import('./MarkerEditorPage'));

export function MarkerEditor(props: { id?: string }): JSX.Element {
  return (
    <Suspense
      fallback={
        <main style={{ padding: 32 }}>
          <div style={{ height: 320, borderRadius: 12, background: 'var(--lightest-gray)' }} />
        </main>
      }
    >
      <MarkerEditorPage {...props} />
    </Suspense>
  );
}

export default MarkerEditor;
